import {ShowHide} from './utils'

const sowHideBloks = {
    triger: document.getElementById('showCategories') as HTMLElement | undefined,
    block: document.getElementById('categoriesBody') as HTMLElement | undefined,
    active: false,
    init() {
        this.toggle();
    },

    toggle() {
        if(this.triger){
            const buttonText =  this.triger.firstElementChild as HTMLElement
            this.triger?.addEventListener('click',()=>{
                this.block?.classList.toggle('activeClass')
                this.active = !this.active
                buttonText.innerText = this.active ? ShowHide.SHOW_LESS : ShowHide.SHOW_MORE
            })
    
        }
  
    },



}

export default sowHideBloks;